module.exports = __webpack_public_path__ + "img/resources-375.26eaf31f.jpg";